export default "__VITE_ASSET__7O2PyrCm__"